export default __webpack_public_path__ + "static/media/definix-overview-kr.c347f669.png";